import { apiSlice } from '@/features/api/apiSlice';

export type DnsStatus = 'verified' | 'missing' | 'invalid' | 'pending';

export type Sender = {
  id: string;
  fromAddress: string;
  fromName: string | null;
  dnsSpfStatus: DnsStatus;
  dnsDkimStatus: DnsStatus;
  dnsDmarcStatus: DnsStatus;
  trackingDomain: string | null;
  verifiedAt: string | null;
  createdAt: string;
};

export type DnsStatusResponse = {
  sender: {
    id: string;
    fromAddress: string;
    domain: string;
    dnsSpfStatus: DnsStatus;
    dnsDkimStatus: DnsStatus;
    dnsDmarcStatus: DnsStatus;
    verified: boolean;
  };
  records: {
    spf: { status: DnsStatus; value: string | null; expected: string };
    dkim: { status: DnsStatus; value: string | null; expected: string };
    dmarc: { status: DnsStatus; value: string | null; expected: string };
  };
  instructions: Array<{ type: string; host: string; value: string; note: string }>;
};

export const sendersApi = apiSlice.injectEndpoints({
  endpoints: (b) => ({
    listSenders: b.query<Sender[], void>({
      query: () => '/senders',
      providesTags: ['Sender'],
    }),
    createSender: b.mutation<Sender, { fromAddress: string; fromName?: string; trackingDomain?: string }>({
      query: (body) => ({ url: '/senders', method: 'POST', body }),
      invalidatesTags: ['Sender'],
    }),
    checkSenderDns: b.mutation<DnsStatusResponse, string>({
      query: (id) => ({ url: `/senders/${id}/dns-status`, method: 'GET' }),
      invalidatesTags: ['Sender'],
    }),
    deleteSender: b.mutation<void, string>({
      query: (id) => ({ url: `/senders/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Sender'],
    }),
  }),
});

export const {
  useListSendersQuery,
  useCreateSenderMutation,
  useCheckSenderDnsMutation,
  useDeleteSenderMutation,
} = sendersApi;
